export const TREZOR_AFFILIATE_TTL = 7889400000; // 3 Months
export const AFFILIATE_BY_TTL = 7889400000; // 3 Months